import { useProductTileUnitToggle } from '@fdc/hooks/useProductTileUnitToggle';

import { getInitialVariantKey } from '../product-tile/add-to-cart-helpers';
import { ProductTile } from '../product-tile/product-tile';
import { ProductTileProps } from '../product-tile/product-tile.types';

export const ProductCarouselTile: React.FC<ProductTileProps> = (props) => {
  const initialVariantKey = getInitialVariantKey(
    props.product?.variants ?? [],
    {
      weight: props.weight,
    }
  );

  const { selectedType: selectedVariantKey, handleSelectedUnitTypeChange } =
    useProductTileUnitToggle<string>({
      initialType: initialVariantKey ?? '',
      quantity: props.quantity,
      selectedUnitType: props.selectedVariantKey,
      onSelectedUnitTypeChange: props.onSelectedVariantKeyChange,
    });

  return (
    <ProductTile
      {...props}
      selectedVariantKey={selectedVariantKey}
      onSelectedVariantKeyChange={handleSelectedUnitTypeChange}
    />
  );
};
